import { postUser, deleteUser } from './http';

export interface TranslationRow {
  id: number;
  key: string;
  module?: string | null; 
  english?: string;         
  russian?: string;         
  ukrainian?: string;       
}

export interface TranslationsMap {
  [key: string]: {
    [lang: string]: string;
  };
}

const TRANSLATE_TABLE_NAME = 'translation';

export const translationApi = {
  async getAll(): Promise<TranslationRow[]> {
    const allTranslations: TranslationRow[] = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await postUser('crud/list', {
        module: TRANSLATE_TABLE_NAME,
        page: page,
        per_page: 10000,
        sort_field: 'id',
        sort_order: 'asc',
      });

      if (response.data && response.data.length > 0) {
        allTranslations.push(...response.data);
        
        if (allTranslations.length >= response.total) {
          hasMore = false;
        } else {
          page++; 
        }
      } else {
        hasMore = false;
      }
    }

    return allTranslations;
  },

  async getByModule(targetModule: string): Promise<TranslationRow[]> {
    try {
      const response = await postUser('crud/list', {
        module: TRANSLATE_TABLE_NAME,
        page: 1,
        per_page: 10000,
        filters: [
          {
            column: 'module',
            operator: '=',
            value: targetModule
          }
        ],
        sort_field: 'id',
        sort_order: 'asc',
      });

      return response.data || [];
    } catch (error) {
      return [];
    }
  },

  async create(data: Omit<TranslationRow, 'id'>): Promise<TranslationRow> {
    const payload = {
      module: TRANSLATE_TABLE_NAME,
      body: {
        key: data.key,
        module: data.module || null,
        english: data.english || '',
        russian: data.russian || '',
        ukrainian: data.ukrainian || '',
      },
    };

    try {
      const response = await postUser('crud/upsert', payload);
      return response.body || response;
    } catch (error) {
      throw error;
    }
  },

  async update(id: number, data: Partial<TranslationRow>): Promise<TranslationRow> {
    const payload = {
      module: TRANSLATE_TABLE_NAME,
      id,
      body: {
        key: data.key,
        module: data.module,
        english: data.english,
        russian: data.russian,
        ukrainian: data.ukrainian,
      },
    };

    try {
      const response = await postUser('crud/upsert', payload);
      return response.body || response;
    } catch (error) {
      throw error;
    }
  },

  async delete(id: number): Promise<void> {
    await deleteUser('crud/delete', {
      module: TRANSLATE_TABLE_NAME,
      id,
    });
  },
};